<mat-card appearance="outlined">
	<mat-card-content class="no-title">
		<span class="row">
			<mat-form-field>
				<mat-label> {{ "HOME.Auftrag suchen" | translate }}</mat-label>

				<span style="display: flex; flex-direction: row;">
					<input #input (keyup.enter)="selectedValue(auto.options.first.value)" [formControl]="formValue" [matAutocomplete]="auto" aria-label="Auftrag suchen" matInput type="text"/>
					<mat-icon (click)="formValue.setValue('')">cancel</mat-icon>
				</span>

				<mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption class="order-autocomplete">
					<cdk-virtual-scroll-viewport [style.height]="(filteredOptionSize | async) + 'px'" itemSize="50" maxBufferPx="500" minBufferPx="300">
						<mat-option (click)="selectedValue(item)" *cdkVirtualFor="let item of filteredOptions | async" [value]="item" class="multiline-mat-option" style="height: 50px">
							<p [innerHTML]="getItemDescription(item.objectSummary)"></p>
						</mat-option>
					</cdk-virtual-scroll-viewport>
				</mat-autocomplete>
			</mat-form-field>
			<ng-container *ngIf="displayShareOrderBtn">
				<fa-icon (click)="shareAuftrag()" [icon]="faCalendar" style="color: black"></fa-icon>
			</ng-container>
		</span>
	</mat-card-content>
	<mat-dialog-actions>
		<button (click)="next()" [innerText]=" 'HOME.Speichern' | translate" class="confirm" mat-stroked-button></button>
		<button [innerText]=" 'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-dialog-close mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>
